import React, { FC } from 'react';

import { DateRangeBox } from 'devextreme-react';

type Props = {
  onChangeDateBegin: (value: string) => void;
  onChangeDateEnd: (value: string) => void;
  dateBegin: string;
  dateEnd: string;
};

const HeaderForm: FC<Props> = ({ dateBegin, dateEnd, onChangeDateBegin, onChangeDateEnd }) => {
  const handleChangeDate = (dateRange: Array<string | Date | number>) => {
    dateRange[0] && onChangeDateBegin(dateRange[0].toString());
    dateRange[1] && onChangeDateEnd(dateRange[1].toString());
  };

  return (
    <div className="d-flex align-end">
      <DateRangeBox
        value={[dateBegin, dateEnd]}
        onValueChanged={(e) => handleChangeDate(e.value)}
        dateSerializationFormat="yyyy-MM-dd"
        stylingMode="underlined"
        useMaskBehavior
      />
    </div>
  );
};

export default HeaderForm;
